import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'react-use';

import OnboardingTutorial from '@pkg/components/OnboardingTutorial/OnboardingTutorial';
import { useAppDispatch } from '@pkg/hooks';
import { useMediaQuery } from '@pkg/providers';

import { collectionPageActions } from '@app/store/slices';

import { ONBOARDING_ACTIVITY_CLASS, ONBOARDING_COLLECTION_FILTERS__CLASS } from '../styles';

const COLLECTION_ONBOARDING_STORE_KEY = 'collection-onboarding';

export const CollectionPageOnboarding = () => {
    const { t: translate } = useTranslation('onboarding');
    const dispatch = useAppDispatch();
    const { tablet } = useMediaQuery();

    const [isCollectionOnboardingShown, setIsCollectionOnboardingShown] = useLocalStorage(
        COLLECTION_ONBOARDING_STORE_KEY,
    );

    const [collectionElement, setCollectionElement] = useState<string>(ONBOARDING_ACTIVITY_CLASS);
    const [showCollectionOnboarding, setShowCollectionOnboarding] = useState(false);
    const onCollectionSwitchDOMElement = () => {
        if (collectionElement !== ONBOARDING_ACTIVITY_CLASS) {
            setCollectionElement(ONBOARDING_ACTIVITY_CLASS);
        } else {
            setCollectionElement(ONBOARDING_COLLECTION_FILTERS__CLASS);
        }
    };
    const onCloseCollectionOnboarding = () => {
        const el = document.querySelector(`.${ONBOARDING_COLLECTION_FILTERS__CLASS}`);
        if (el) {
            const clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: true,
            });
            el.dispatchEvent(clickEvent);
        }
        setIsCollectionOnboardingShown(true);
        setShowCollectionOnboarding(false);
    };

    useEffect(() => {
        let timeout;
        if (isCollectionOnboardingShown) return;
        if (tablet) {
            const handler = () => {
                dispatch(collectionPageActions.setShowActivitySidebar(true));
                setShowCollectionOnboarding(true);
            };

            timeout = setTimeout(handler, 2000);
        }
        return () => clearTimeout(timeout);
    }, [dispatch, isCollectionOnboardingShown, tablet]);

    if (tablet && showCollectionOnboarding)
        return (
            <OnboardingTutorial
                useLockScroll={false}
                highlightElement={collectionElement}
                onClose={onCloseCollectionOnboarding}
                onSlideChange={onCollectionSwitchDOMElement}
                size="large"
                slides={[
                    {
                        title: translate('activity-panel__slide1__title'),
                        content: translate('activity-panel__slide1__content'),
                        button: translate('activity-panel__slide1__button'),
                        imageURL: '/assets/img/onboarding/activity-panel.webp',
                    },
                    {
                        title: translate('collection-filters__title'),
                        content: translate('collection-filters__content'),
                        button: translate('collection-filters__button'),
                        imageURL: '/assets/img/onboarding/collection-filters.png',
                    },
                ]}
            />
        );

    return null;
};
